"use strict";
/*
  in order to use the xs, sm, md, lg, xl alias,
  need to use an array with object properties
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpointValues = exports.breakpoints = void 0;
// cast array to Breakpoints type
exports.breakpoints = ['400px', '600px', '900px', '1200px', '1536px'];
exports.breakpointValues = {
    xs: 400,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536
};
// alias, https://styled-system.com/responsive-styles/#using-objects
exports.breakpoints.xs = exports.breakpoints[0];
exports.breakpoints.sm = exports.breakpoints[1];
exports.breakpoints.md = exports.breakpoints[2];
exports.breakpoints.lg = exports.breakpoints[3];
exports.breakpoints.xl = exports.breakpoints[4];
// Avoid conflict with MUI up()
exports.breakpoints.up_custom = function (value) { return "(min-width: ".concat(exports.breakpoints[value], ")"); };
